import { Outlet } from 'react-router-dom'
import React from 'react'

const Invoice = () => {
  return (
    <Outlet/>
  )
}

export default Invoice